import { render, staticRenderFns } from "./IELTSConverterView.vue?vue&type=template&id=38023872&scoped=true"
import script from "./IELTSConverterView.vue?vue&type=script&lang=js"
export * from "./IELTSConverterView.vue?vue&type=script&lang=js"
import style0 from "./IELTSConverterView.vue?vue&type=style&index=0&id=38023872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38023872",
  null
  
)

export default component.exports